import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import lang from '../../constants/Languages.js';
import {Link} from 'react-router-dom';
import numberWithSpaces from '../../scripts/NumberWithSpaces.js';

//import img
import chevronDownAccent from '../../assets/icons/chevron-down-accent.svg';
import chevronUpAccent from '../../assets/icons/chevron-up-accent.svg';
import arrowDark from '../../assets/icons/arrow-circle-full.svg';
import arrowLight from '../../assets/icons/arrow-full-light.svg';
import star from '../../assets/icons/star.png';

class DetailsListItemContent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpened: false,
        };
    };

    componentDidMount() {
        this.updateActiveElem();
    };

    updateActiveElem = () => {
        const {setActiveElem} = this.props;

        if (this.activeElem) {
            this.activeElemOffset = this.activeElem.getBoundingClientRect();
            setActiveElem(this.activeElemOffset.top - 30);
        }
    };

    toggleOpened = () => {
        this.setState({isOpened: !this.state.isOpened});
    };

    render() {
        const {clang, label, id, shortDescription, recordsNumber, currentHeading} = this.props;
        const {isOpened} = this.state;

        const isSpecial = label.toLowerCase().includes(lang[clang].characteristics.special_topic.toLowerCase());

        return (
            <div className="structure__list-item__content">
                <div className="structure__list-item__content--main">
                    <div className={`structure__label-container ${currentHeading === id ? 'active' : ''}`}
                      ref={(activeElem) =>  currentHeading === id ? this.activeElem = activeElem : false}>
                        <Link to={`/headings/about/details?q=*&area=all&HEADINGS[0]=${id}`} className="structure__label" title={label}>
                            <strong>{label}</strong>
                        </Link>
                        {isSpecial ? <img className="structure__img--special" src={star} alt={lang[clang].characteristics.special_topic} title={lang[clang].characteristics.special_topic}/> : false}
                        <div className="structure__count">
                           ({numberWithSpaces(!!recordsNumber ? recordsNumber : 0)})
                        </div>
                    </div>
                    <div className="structure__info">
                        {shortDescription &&
                            ((!isOpened &&
                                <button className="structure__info__button" onClick={() => this.toggleOpened()} title={lang[clang].characteristics.field_desc}>
                                    {lang[clang].characteristics.field_desc}
                                    <img className="structure__info__button-img" src={chevronDownAccent} alt="" />
                                </button>) ||
                            (isOpened &&
                                <button className="structure__info__button--opened" onClick={() => this.toggleOpened()} title={lang[clang].characteristics.field_desc}>
                                    {lang[clang].characteristics.field_desc}
                                    <img className="structure__info__button-img" src={chevronUpAccent} alt="" />
                                </button>))}
                        <Link to={`/headings/about/details?q=*&area=all&HEADINGS[0]=${id}`} className="structure__details" title={lang[clang].headings_details.show_details}>
                            {lang[clang].headings_details.show_details}
                            <img src={arrowDark} className="card__yearbook__number-arrow--dark" alt="" />
                            <img src={arrowLight} className="card__yearbook__number-arrow--light" alt="" />
                        </Link>
                    </div>
                </div>
                {isOpened && shortDescription &&
                    <div className="structure__info__desc" dangerouslySetInnerHTML={{__html: shortDescription}}>
                    </div>}
            </div>
        );
    };
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default withRouter(connect(mapStateToProps)(DetailsListItemContent));



// WEBPACK FOOTER //
// ./src/components/characteristics-details/DetailsListItemContent.js